import { c as _c } from "react/compiler-runtime";
import { fetchGlobalServiceProfile, fetchGlobalServiceProfileTranslate, fetchGlobalServiceProfileUpdate } from '@module/apis/client-side/global-service';
import type { BJProfileFieldData, FetchGlobalServiceProfileParams, FetchGlobalServiceProfileResponse, FetchGlobalServiceProfileTranslateResponse, FetchGlobalServiceProfileUpdateParams } from '@module/apis/client-side/global-service/type';
import type { ApiBaseResponse } from '@module/apis/type';
import { type UseMutationOptions, useMutation, useQuery } from '@tanstack/react-query';
import type { CustomUseQueryOptions } from '../type';
import { globalServiceQueryKeys } from './globalServiceQueryKeys';
export const useFetchGlobalServiceProfileQuery = (params, options) => {
  const $ = _c(8);
  let t0;
  if ($[0] !== params) {
    t0 = globalServiceQueryKeys.fetchGlobalServiceProfile(params);
    $[0] = params;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== params) {
    t1 = () => fetchGlobalServiceProfile(params);
    $[2] = params;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== options || $[5] !== t0.queryKey || $[6] !== t1) {
    t2 = {
      queryKey: t0.queryKey,
      queryFn: t1,
      ...options
    };
    $[4] = options;
    $[5] = t0.queryKey;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return useQuery(t2);
};
export const useFetchGlobalServiceProfileMutation = options => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = globalServiceQueryKeys.fetchGlobalServiceProfileUpdate();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== options) {
    t1 = {
      mutationKey: t0.queryKey,
      mutationFn: _temp,
      ...options
    };
    $[1] = options;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return useMutation(t1);
};
export const useFetchGlobalServiceProfileTranslateMutation = options => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = globalServiceQueryKeys.fetchGlobalServiceProfileTranslate();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== options) {
    t1 = {
      mutationKey: t0.queryKey,
      mutationFn: _temp2,
      ...options
    };
    $[1] = options;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return useMutation(t1);
};
function _temp(params) {
  return fetchGlobalServiceProfileUpdate(params);
}
function _temp2(params) {
  return fetchGlobalServiceProfileTranslate(params);
}